



























import {
  defineComponent,
  ref,
  computed,
  watch,
  reactive,
  watchEffect
} from "@vue/composition-api";
import { Chart } from "chart.js";
import ChartCard from "@/components/Atoms/ChartCard/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import UniversityEntryTable from "../UniversityEntryTable/index.vue";
import {
  chartGray02,
  chartBlueLevel01,
  chartBlueLevel02,
  chartBlueLevel03,
  chartBlueLevel04,
  chartBlueLevel05,
  chartBlueLevel06,
  chartBlueLevel07
} from "@/assets/styles/vars";

export default defineComponent({
  components: {
    Heading,
    ChartCard,
    UniversityEntryTable
  },
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    period: {
      type: String,
      default: ""
    }
  },
  name: "UniversityEntryChart",
  setup(props) {
    const canvasRef = ref<HTMLCanvasElement | null>(null);
    const state = reactive<{ chart: Chart | null }>({
      chart: null
    });

    const universityNames = ref([
      "旧帝大",
      "早慶上一工",
      "GMARCH",
      "関関同立",
      "日東駒専",
      "産近甲龍",
      "その他国公立",
      "その他"
    ]);

    const isEmptyData = ref(false);

    const tableData = computed(() => props.data);
    const displayPeriod = computed(() => props.period);

    const universityChartData = computed(() => {
      const sumObj: any = props.data.reduce((acc: any, cur: any) => {
        Object.keys(cur).forEach(key => {
          if (key !== "date") {
            acc[key] = (acc[key] || 0) + cur[key];
          }
        });
        return acc;
      }, {} as { [key: string]: number });

      return Object.values(sumObj);
    });

    watch(universityChartData, () => {
      if (universityChartData) {
        createCharts(
          universityNames.value as Array<string>,
          universityChartData.value as Array<number>
        );
      }
    });

    watchEffect(() => {
      isEmptyData.value = universityChartData.value.every(val => val === 0);
    });

    function createCharts(universityNames: Array<string>, data: Array<number>) {
      if (canvasRef.value === null) return;
      const canvas = canvasRef.value.getContext("2d");
      if (canvas === null) return;

      const universityData = {
        labels: universityNames,
        datasets: [
          {
            data: data,
            backgroundColor: [
              chartBlueLevel01,
              chartBlueLevel02,
              chartBlueLevel03,
              chartBlueLevel04,
              chartBlueLevel05,
              chartBlueLevel06,
              chartBlueLevel07,
              chartGray02
            ]
          }
        ]
      };

      if (state.chart) {
        state.chart.data.datasets = universityData.datasets;
        state.chart.data.labels = universityData.labels;
        state.chart.update();
      } else {
        const chart = new Chart(canvas, {
          type: "doughnut",
          options: {
            cutoutPercentage: 30,
            legend: {
              position: "right",
              display: true
            }
          }
        });

        state.chart = chart;
        state.chart.data.datasets = universityData.datasets;
        state.chart.data.labels = universityData.labels;
        state.chart.update();
      }
    }
    return {
      canvasRef,
      isEmptyData,
      tableData,
      displayPeriod,
      state,
      universityNames,
      universityChartData,
      createCharts
    };
  }
});
